//Import Modules
import LocomotiveScroll from 'locomotive-scroll';
import $ from 'jquery';
import gsap from 'gsap';
import { load3d_er } from './3d-can_er';
import { load3d_abm } from './3d-can_abm';
import { load3d_oi } from './3d-can_oi';
import { initBackgroundChange } from './background-change';


//Mobile Device Check
var mobilecheck=false;
if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
  // true for mobile device
  mobilecheck=true;
};

//Session Storage Variables
var loading;
var sound;
loading = sessionStorage.getItem("loadingcheck");
sound = sessionStorage.getItem("soundcheck");
if(loading!="false"){
  $('.loading-screen').css("display", "block");
}
//Fades in the "Über uns" Headline further down the Page. Independent of the
//Loading Screen, so it has to run on every Visit.
gsap.to('.hl', {opacity: 1, duration: 2});
//Reveals the Landing Headline immediately only when the Loading Screen is
//skipped. On a first Visit the Click Handlers below do it once the Screen is
//gone, otherwise the staggered Letter Animation would play behind it.
if(loading=="false"){
  $('.landing-headline').addClass('in-view');
}


//Define Click Sounds 
const clicksound1 = document.createElement("audio");
clicksound1.src = "can_opening.ogg";
clicksound1.crossOrigin='anonymous';
const clicksound2 = document.createElement("audio");
clicksound2.src = "bubble_sound.mp3";
clicksound2.crossOrigin='anonymous';

//Smooth Scrolling
const scroll = new LocomotiveScroll({
    el: document.querySelector('[data-scroll-container]'),
    smooth: true,
    multiplier: 1,
    touchMultiplier: 3.5,
    smartphone: {
      breakpoint: 760,
      smooth: false,
      getDirection: true,
    },
    tablet: {
      breakpoint: 1020,
      smooth: false,
      getDirection: true,
    }
});

// //GSAP Animations
//Hides the Loading Screen as one Timeline instead of four independent Tweens.
//The Steps can no longer drift apart, and both the Headline Reveal and the
//final display:none hang on the actual End of the Fade instead of a hardcoded
//Timeout. The last Number of each Line is the Start Time on the Timeline.
const hideLoadingElements = () =>{
  removeHoverClass();
  gsap.timeline({
    onComplete: ()=>{
      $('.loading-screen').addClass('remove').css("display", "none");
    }
  })
    .to('.text-loading', {opacity: 0, duration: 0.5, ease: "power2.out"}, 0)
    .to('.bt-loading',   {opacity: 0, duration: 0.4, ease: "power2.out"}, 0.1)
    .to('.sound-link',   {opacity: 0, duration: 0.4, ease: "power2.out"}, 0.2)
    //The Screen itself gets the long, eased Fade - this is what makes it smooth
    .to('.loading-screen', {opacity: 0, duration: 1.1, ease: "power2.inOut"}, 0.5)
    //Fires 0.7s before the Timeline ends, so the Headline already animates
    //while the Screen is still fading and emerges through it
    .add(()=>{ $('.landing-headline').addClass('in-view'); }, "-=0.7");
}
const hideLoadingText = () =>{
  gsap.to('.pretext-loading', {opacity: 0, duration: 0.7});
}
const showLoadingElements = () =>{
  hideLoadingText();
  gsap.to('.text-loading', {opacity: 1, duration: 0.3, delay:1.5});
  gsap.to('.sound-link', {opacity: 1, duration: 0.3, delay:1.9});
  gsap.to('.bt-loading', {opacity: 1, translateY:0, rotateX:0, duration: 0.3, delay:0.7});
}


//Initialise Loading Screen
//Show Button if all Assests are loaded
$(window).on("load",()=>{
  setTimeout(()=>{
    showLoadingElements();
  },6700);
});
//Remove Loading Section on Button Click
$('.bt-loading').on("click", ()=>{
  sessionStorage.setItem("soundcheck", true);
  sessionStorage.setItem("loadingcheck", false);
  sound= sessionStorage.getItem("soundcheck");
  clicksound2.play();
  hideLoadingElements();
});
//Remove Loading Section on Link Click + Deactivate Sound
$('.sound-link').on("click", ()=>{
  sessionStorage.setItem("soundcheck", false);
  sessionStorage.setItem("loadingcheck", false);
  sound= sessionStorage.getItem("soundcheck");
  hideLoadingElements();
});

//Initialise Custom Cursor
function initCursor(){
  $(document).on("mousemove", (e) => {
    setTimeout(function() {
        $('.cursor')
          .eq(0)
          .css({
            left: e.pageX,
            top: e.pageY,
          });
      }, 0);
  });
}

//Set Hover Elements for Custom Cursor to change Color
function initCursorHover(){
  $('.hoverable').on("mouseenter", () => {
    $('.cursor').addClass('hover');
  });
  $('.hoverable').on("mouseleave", () => {
    $('.cursor').removeClass('hover');
  });
}

//Remove Hover Class when the Loading Screen is dismissed
function removeHoverClass(){
  $('.cursor').removeClass('hover');
}

//Initialise Mobile Menu
function initMobileMenu(){
  $('.hamburger').on("click", ()=>{
    $('.menu').toggleClass('menu-open');
    $('.hamburger').toggleClass('open');
    $('.menu-items').toggleClass('show-list-items');
    $('.menu-link').toggleClass('show-links');
  });
  $('.menu-items').on("click", ()=>{
    $('.menu').toggleClass('menu-open');
    $('.hamburger').toggleClass('open');
    $('.menu-items').toggleClass('show-list-items');
    $('.menu-link').toggleClass('show-links');
  });
}

//Initialise Sound
function initClickSounds(){
    $('.bt-sound').on("mouseover", () => {
      if(sound=="true"){
        clicksound1.play();
      }
    });
    $('.hover-sound').on("mouseover", () => {
      if(sound=="true"){
        clicksound2.play();
      }
    });
}

//Initialise  Hover Headline Changes in about Section
function headlineChanges(){
  $('.bt-info-1').on("mouseenter",()=>{
    setTimeout(()=>{
      $('.hd-info-1').addClass('appear');
    },500);
    $('.hd-info-0').addClass('disappear');
  });
  $('.bt-info-1').on("mouseleave",()=>{
    setTimeout(()=>{
      $('.hd-info-0').removeClass('disappear');
    },500);
    $('.hd-info-1').removeClass('appear');
  });
  $('.bt-info-2').on("mouseenter",()=>{
    setTimeout(()=>{
      $('.hd-info-2').addClass('appear');
    },500);
    $('.hd-info-0').addClass('disappear');
  });
  $('.bt-info-2').on("mouseleave",()=>{
    setTimeout(()=>{
      $('.hd-info-0').removeClass('disappear');
    },500);
    $('.hd-info-2').removeClass('appear');
  });
  $('.bt-info-3').on("mouseenter",()=>{
    setTimeout(()=>{
      $('.hd-info-3').addClass('appear');
    },500);
    $('.hd-info-0').addClass('disappear');
  });
  $('.bt-info-3').on("mouseleave",()=>{
    setTimeout(()=>{
      $('.hd-info-0').removeClass('disappear');
    },500);
    $('.hd-info-3').removeClass('appear');
  });
  $('.bt-info-4').on("mouseenter",()=>{
    setTimeout(()=>{
      $('.hd-info-4').addClass('appear');
    },500);
    $('.hd-info-0').addClass('disappear');
  });
  $('.bt-info-4').on("mouseleave",()=>{
    setTimeout(()=>{
      $('.hd-info-0').removeClass('disappear');
    },500);
    $('.hd-info-4').removeClass('appear');
  });
  $('.bt-info-5').on("mouseenter",()=>{
    setTimeout(()=>{
      $('.hd-info-5').addClass('appear');
    },500);
    $('.hd-info-0').addClass('disappear');
  });
  $('.bt-info-5').on("mouseleave",()=>{
    setTimeout(()=>{
      $('.hd-info-0').removeClass('disappear');
    },500);
    $('.hd-info-5').removeClass('appear');
  });
}

//Run all functions when Document is ready
$(function() {
  initCursor();
  initCursorHover();
  load3d_er();
  load3d_abm();
  load3d_oi();
  initMobileMenu();
  initBackgroundChange(scroll);
  headlineChanges();
  initClickSounds();
});
